import React, { FC, useState } from "react";
import { Field } from "react-final-form";
import { AccordionItem } from "./AccordionItem";
import { makeStyles, Typography } from "@material-ui/core";
import type { IAccordionItem, IAccordionListProps } from "./types";

const useStyles = makeStyles(() => ({
  title: {
    marginTop: 8,
    marginBottom: 16,
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
}));

export const AccordionList: FC<IAccordionListProps> = ({
  title,
  fieldName,
  configs,
}) => {
  const [expanded, setExpanded] = useState<number | boolean>();
  const classes = useStyles();

  const handleExpand = (item: IAccordionItem) => (_, newExpanded) => {
    setExpanded(newExpanded ? item.type : false);
  };

  return (
    <>
      {!!title && <Typography className={classes.title}>{title}</Typography>}
      {configs.map((item) => (
        <Field
          key={item.type}
          isExpanded={expanded === item.type}
          isRequired={item.isRequired}
          onExpand={() => handleExpand(item)}
          title={item.name}
          type="text"
          name={`${fieldName}.type_${item.type}`}
          component={AccordionItem}
        />
      ))}
    </>
  );
};
